import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ButtonProps } from 'react-native-paper';
import { Button } from 'react-native-paper';

import { EditLocationIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

// Toggles between contained (map selection active) and outlined, so it
// cannot use OutlinedButton — the outline theme is applied inline (unused in
// contained mode).
export const ChangePositionButton: FC<
  Pick<ButtonProps, 'onPress'> & { canSelectOnMap: boolean }
> = ({ onPress, canSelectOnMap }) => {
  const { t } = useTranslation(LocalizationNameSpace.POST_EDITOR, {
    keyPrefix: 'screens.post-editor.locationPicker'
  });
  const theme = useAppTheme();

  return (
    <Button
      mode={canSelectOnMap ? 'contained' : 'outlined'}
      contentStyle={{ height: 32 }}
      labelStyle={{ marginVertical: 'auto' }}
      onPress={onPress}
      icon={({ color, size }) => (
        <EditLocationIcon fill={color} width={size} height={size} />
      )}
      theme={{ colors: { outline: theme.colors.primary } }}
    >
      {t('changePosition')}
    </Button>
  );
};
